var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('InnerHeader',{attrs:{"cover":require('../../assets/img/news/cover.jpg'),"bgColor":'#164194',"bgPosition":'0 40%',"links":_vm.links}}),(!_vm.$route.query.id)?_c('News'):(_vm.$route.query.id)?_c('NewsPreview'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }